export default theme => ({
  root: {
    padding: theme.spacing(0)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  progressWrapper: {
    paddingTop: "48px",
    paddingBottom: "24px",
    display: "flex",
    justifyContent: "center"
  },
  pagination: {
    marginTop: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  row: {
    minHeight: "42px",
    display: "flex",
    flexWrap: "wrap",
    alignContent: "stretch",
    alignItems: "stretch",
    marginTop: theme.spacing(1)
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  spacer: {
    flexGrow: 1
  },
  searchInput: {
    // marginTop: "10px"
    background: theme.palette.background.light
  },
  listClasses: {
    backgroundColors: "white"
  },
  enabledIntents: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingTop: "0px !important"
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  buttonAddNewTask: {
    margin: theme.spacing(0)
  }
});
